import authInterceptor from "../../AuthInterceptor";

export const DataManagementAPI = {
    getTableList: () =>
        authInterceptor.get(`ranking-api/truncate_api/`)
            .then((response) => response.data)
            .catch((error) => error.response),
    deleteTable: (bodyData) =>
        authInterceptor.post(`ranking-api/truncate_api/`, bodyData)
            .then((response) => response.data)
            .catch((error) => error.response)


}